import { TimeApiResponse } from '@/shared/services/getTimeApiDate';
import { useMutation } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';

interface CreateSessionData extends Partial<TimeApiResponse> {
  org: number;
}

const useCreateSessionMutation = () =>
  useMutation({
    mutationKey: ['createSession'],
    mutationFn: async (data: CreateSessionData): Promise<any> => {
      return await post<CreateSessionData>('/v1.0/session', data);
    },
  });

export default useCreateSessionMutation;
